import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=3bd5e603&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=3bd5e603&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5e603",
  null
  
)

export default component.exports